function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 31C20.1823 31 18.4141 30.2501 17.0914 28.8746C15.7649 27.495 15 25.5997 15 23.6C15 23.2235 15.0347 22.8481 15.1032 22.4713L12.6842 20.0523C12.254 21.1749 12 22.3533 12 23.6C12 26.3583 13.0536 29.0035 14.9289 30.9539C16.8043 32.9043 19.3478 34 22 34C23.3295 34 24.6317 33.7247 25.8362 33.2043L23.4672 30.8354C22.9872 30.9443 22.4954 31 22 31ZM29 23.6261L31.6606 26.2867C31.884 25.4177 32 24.5151 32 23.6C32 19.1935 28.8247 15.6401 25.9193 12.3887L25.6338 12.069L24.2376 10.5056C23.0448 9.16999 20.9552 9.16999 19.7624 10.5056L18.3663 12.069L18.0834 12.3856C18.0325 12.4425 17.9815 12.4995 17.9305 12.5566L20.0554 14.6815C20.1588 14.5656 20.2629 14.4491 20.3677 14.3317L20.6039 14.0673L20.6043 14.0667L22 12.5039L23.3953 14.0663L23.3956 14.0666L23.3961 14.0673L23.6351 14.335C25.0837 15.9571 26.4021 17.4335 27.4104 19.002C28.4489 20.6173 29 22.1007 29 23.6C29 23.6087 29 23.6174 29 23.6261Z",
  fill: "currentcolor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 21.2195,
  transform: "matrix(-0.707107 0.707107 0.707107 0.707107 15.6963 14.5752)",
  fill: "currentcolor"
});

var SvgRemoveWatermark = function SvgRemoveWatermark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveWatermark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-watermark.6826f288.svg";
export { ForwardRef as ReactComponent };